import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { ExternalLink } from 'lucide-react';

const Portfolio = ({ t }) => {
  const navigate = useNavigate();

  const portfolioSites = [
  {
    name: "Alpine Retreat",
    type: t.portfolio.sites.alpineRetreat.type,
    image: "https://images.unsplash.com/photo-1551882547-ff40c63fe5fa?w=800&q=80",
    description: t.portfolio.sites.alpineRetreat.description,
    slug: "/example/alpine-retreat"
  },
  {
    name: "Lakeview Manor",
    type: t.portfolio.sites.lakeviewManor.type,
    image: "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800&q=80",
    description: t.portfolio.sites.lakeviewManor.description,
    slug: "/example/lakeview-manor"
  },
  {
    name: "Urban Suites",
    type: t.portfolio.sites.urbanSuites.type,
    image: "https://images.unsplash.com/photo-1590490360182-c33d57733427?w=800&q=80",
    description: t.portfolio.sites.urbanSuites.description,
    slug: "/example/urban-suites"
  },
  {
    name: "Château Belleville",
    type: t.portfolio.sites.chateauBelleville.type,
    image: "https://images.unsplash.com/photo-1445019980597-93fa8acb246c?w=800&q=80",
    description: t.portfolio.sites.chateauBelleville.description,
    slug: "/example/chateau-belleville"
  },
  {
    name: "Zen Retreat",
    type: t.portfolio.sites.zenRetreat.type,
    image: "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80",
    description: t.portfolio.sites.zenRetreat.description,
    slug: "/example/zen-retreat"
  }];


  return (
    <section id="portfolio" className="py-24 bg-slate-900">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="md:text-5xl !font-bold !text-4xl mb-4 text-white">{t.portfolio.title}

          </h2>
          <p className="max-w-2xl !text-xl mx-auto text-slate-400">{t.portfolio.subtitle}

          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {portfolioSites.map((site, index) =>
          <Card
            key={index}
            className="bg-slate-800/50 border-slate-700 hover:bg-slate-800 transition-all duration-300 hover:scale-105 hover:shadow-xl cursor-pointer overflow-hidden group"
            onClick={() => navigate(site.slug)}>

              {/* Image */}
              <div className="relative h-48 overflow-hidden">
                <img
                src={site.image}
                alt={site.name}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300" />

                <div className="absolute inset-0 bg-gradient-to-t from-slate-900 to-transparent opacity-60"></div>
                <div className="absolute bottom-4 right-4">
                  <ExternalLink className="h-6 w-6 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                </div>
              </div>

              <CardHeader>
                <CardTitle className="text-white text-2xl">
                  {site.name}
                </CardTitle>
                <CardDescription className="text-slate-400 text-sm">
                  {site.type}
                </CardDescription>
              </CardHeader>
              <CardContent>
                <p className="text-slate-400 text-base">
                  {site.description}
                </p>
              </CardContent>
            </Card>
          )}
        </div>

        <div className="text-center mt-12">
          <p className="text-slate-500 text-sm">
            {t.portfolio.disclaimer}
          </p>
        </div>
      </div>
    </section>);

};

export default Portfolio;
